import React, { Component } from "react"

import { FamilyIntakeStatus } from "./FamilyIntakeStatus"
import { IntakeNeedExpectations } from './IntakeNeedExpectations'
import { GetIntakesEP, Intake2FamilyEPmbo } from '../../variables/Config'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { familyNames } from '../FamilyProgram/ProgramTabs'
import { saveSubAcf2DB } from '../Tree/Utils'
import YSpinner from  '../../elements/Spinner/Spinner'

export default class TabsIntake extends Component {
    constructor(props){
        super(props)
        this._isMounted = false;
        this.state = {
            cptId : this.props.cptId, // 6296, // get from props
            isLoading: true,
            isUpdating: false,
            terms: [],
            cpt: {},
            intake_info: [],
            intake:[],
            title: ""
        }
    }
    inUpdate = (onOff) => {
       // console.log("inUpdate =", onOff)
        if (this._isMounted)
            this.setState({isUpdating:onOff})
    }
    handleNewFamily = () => {
        //let uri_ep = "http://yahav/wp-json/mbo/v3/intake2family" 
        const uri_ep = Intake2FamilyEPmbo()
        let intakeInfo = this.state.intake_info
        intakeInfo['intake_status'] = 'קבלה לתכנית'
        this.setState({isPosting:true, intake_info: intakeInfo})
        let body ={
            "acf": { "intake": this.state.intake, "intake_info": this.state.intake_info }
        }
        fetch(uri_ep, {
            method: 'POST',
            headers: { 
             //   'Accept': 'application/json', 'Authorization': 'Basic '+btoa('meital:@site2goal.')
                'Accept': 'application/json', 'Authorization': 'Bearer' + this.props.mbouser.token
            },
            body: JSON.stringify({body}) 
        }).then(response => {
            if (response.ok) {
                if (this._isMounted)
                    this.setState({isPosting:false})
                //alert("משפחה חדשה נוספה לתכנית")
                // console.log("handleNewIntake: got ok from creating / updating new intake", response.json())
                return true // response.json()
            } else  
                throw new Error('handleNewFamilyinProgram: Something went wrong on fetch POST ... ', this.state)
        }).catch(restError => {
            console.log("handleNewIntake, fetch POST error:", restError) /*this.setState({ restError: restError, isPosting: false }*/
            alert("תקלת מערכת - משפחהבתוכנית לא נוספה!")
        })
    }
    fetchTerm(url) {
        fetch(url/*, { signal: this.abortController.signal }*/)
        .then(response => {
            if (!this._isMounted) return null
            if (response.ok)
                return response.json()
            throw new Error('fetchTerm: Something went wrong ...')
        })
        .then(cpt => {             
            var terms = Object.entries(cpt['acf'])
            var title = Object.values(cpt['title'])
            var intake_info = cpt['acf']['intake_info']
            var intake = cpt['acf']['intake']
            
            if (!this._isMounted) return null
            this.setState({cpt, terms, title, intake_info, intake, isLoading: false})
            
            return (terms) // void - no one is looking...
        })//.then( () => { //FOR DEBUG PURPOSES console.log("title",this.state.cpt['title'])  })
        .catch(restError => {
            if (restError.name === 'AbortError') return; 
            if (!this._isMounted) return null
            this.setState({ restError: restError, isLoading: false })
        })
        return null
    }
    componentDidMount(){ // add constructor..
        this._isMounted = true
        //this.setState({isLoading: true  })     // modalRoot: document.getElementById('modal-root'),
        //var uri = "http://yahav/wp-json/wp/v2/digma_intakes/"+ this.state.cptId +"?fields=id,title,acf" 
        const uri = GetIntakesEP() + "/" + this.state.cptId + "?fields=id,title,acf" 
        
        this.fetchTerm(uri)
    }
    componentWillUnmount(){ // add constructor..
        this._isMounted = false
    }
    // need id, table id & data

    onSaveSubTable = (cptId, data, dataId, dataType, inUpdate, mbouser) => {
        // this.setState({isOnSaveTable:true})
        // console.log("onSaveSubTable: dataId = ", dataId)
        saveSubAcf2DB(cptId, data, dataId, dataType, inUpdate, mbouser)
        if (dataId === 'intake_info'){
            console.log('update rlist')
            this.props.updateIlist(data)
        }
    }
    
    render(){
        if (this.state.isLoading)
            return (<YSpinner />)
        if (this.state.isPosting)
            return (<div><h1>מעדכן...</h1><p>הוספת משפחה לתוכנית היא פעולה מורכבת<br />עוד כמה שניות...</p></div>)
        //if (this.state.isOnSaveTable)
        //    return (<h1>מעדכן...</h1>)

        //console.log("TABS FamilyMortgage", this.state.family_mortgage)
        const familyPostId = this.state.cptId // get as input from list
        //var family_title = this.state.cpt['acf']['intake_referral']['family_referral_family_name'] 
        //var female_name = this.state.cpt['acf']['intake_referral']['family_referral_woman_firstname']
        //var male_name = this.state.cpt['acf']['intake_referral']['family_referral_man_firstname']
        //const inf = this.state.cpt['acf']['intake_referral']
        const iinfo = this.state.cpt['acf']['intake_info']
        const fname = familyNames(iinfo['intake_family_name'], iinfo['intake_family_woman_name'], iinfo['intake_family_man_name'])
        //console.log('FAMILY NAMES ', iinfo['intake_family_name'], iinfo['intake_family_woman_name'], iinfo['intake_family_man_name'])
        
        return(
            <div>
                {fname}
                <div className="clear-both">
                    <Tabs  >
                        {this.state.isUpdating ? <YSpinner message={"מעדכן..."} /> : null }

                        <TabList>
                            <Tab>סטטוס</Tab>
                            <Tab>צרכים וציפיות</Tab>
                        </TabList>
                        <br />
                        <TabPanel >  
                            <FamilyIntakeStatus tableTitle={"סטטוס אינטייק"} 
                                familyPostId={familyPostId} 
                                data={this.state.intake_info}
                                subTableId = {"intake_info"}
                                inUpdate = {this.inUpdate}
                                save2DB = {this.onSaveSubTable}
                                mbouser = {this.props.mbouser}
                                addFamily2Program = {this.handleNewFamily} 
                                />
                        </TabPanel>
                        <TabPanel >
                            {/*<h1>שאלון צרכים וציפיות</h1>*/}
                            <IntakeNeedExpectations tableTitle={"שאלון צרכים וציפיות"} 
                                familyPostId={familyPostId} 
                                data={this.state.intake}
                                subTableId = {"intake"}
                                inUpdate = {this.inUpdate}
                                save2DB = {this.onSaveSubTable} 
                                mbouser = {this.props.mbouser}
                                />
                        </TabPanel>
                        
                    </Tabs>
                </div>
            </div>

        )
    }
}
